export default "__VITE_ASSET__Ddgzu6aO__"